var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Create Run Sheet")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isResetLoad
    },
    on: {
      "update:active": function($event) {
        _vm.isResetLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR')),
      expression: "errors.has('SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SR')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tripDayflag == 1 || _vm.tripDateFlag == true),
      expression: "tripDayflag == 1 || tripDateFlag== true"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please close existing trip from SR app.! ")]), _vm._v(" "), (_vm.isShowCODAmount) ? _c('b-alert', {
    staticClass: "p-0 border-0",
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "transparent"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_c('span', {
    staticClass: "text-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.srCODPendingMsg)
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.IsSRNeedTrip) ? _c('div', {
    staticClass: "col-md-2 mr-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.srId == false
    },
    on: {
      "click": function($event) {
        return _vm.clearTrip()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [(_vm.IsSRNeedTrip) ? _c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.startTripFlag == false || _vm.tripDayflag == 1 || _vm.tripDateFlag == true
    },
    on: {
      "click": function($event) {
        return _vm.startTrip()
      }
    }
  }, [_vm._v(_vm._s(_vm.tripTitle))]) : _vm._e(), _vm._v(" "), (_vm.IsSRNeedTrip) ? _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.srId == false
    },
    on: {
      "click": function($event) {
        return _vm.clearTrip()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e(), _vm._v(" "), (_vm.tripTitle == 'Continue with existing trip' && _vm.IsSRNeedTrip) ? _c('div', [_c('span', {
    staticClass: "checkTripDate",
    staticStyle: {
      "font-size": "12px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v(" Trip Created Date : " + _vm._s(_vm.tripCreatedDate) + " ")])]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.tripTitle == 'Start Trip' && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && tripTitle=='Start Trip' && IsSRNeedTrip"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Select Vehicle Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-primary1 mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('bike')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" Bike")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('vehicle')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Vehicle")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.vehicleType && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && vehicleType && IsSRNeedTrip"
    }],
    staticClass: "row mt-2"
  }, [((_vm.vehicleType == 'bike' && _vm.srVehicleList.length == 0) || _vm.isVehicleReplaced == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleNo),
      expression: "vehicleNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "vehicleNo"
    },
    domProps: {
      "value": (_vm.vehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleNo),
      expression: "errVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")])], 1)], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srVehicleList,
      "selected-option": _vm.vehicleNoItemObj,
      "name": "vehicleNo",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "select": _vm.selectVehicleNo
    },
    model: {
      value: (_vm.vehicleNo),
      callback: function($$v) {
        _vm.vehicleNo = $$v
      },
      expression: "vehicleNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Open KM")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleOpenKM),
      expression: "vehicleOpenKM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Open KM",
      "name": "vehicleOpenKM"
    },
    domProps: {
      "value": (_vm.vehicleOpenKM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleOpenKM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleKm),
      expression: "errVehicleKm"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleKm))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vehicleType == 'bike' && _vm.srVehicleList.length > 0),
      expression: "vehicleType=='bike' && srVehicleList.length>0"
    }],
    staticClass: "col-md-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": function($event) {
        return _vm.isVehicleReplaceCheck($event)
      }
    },
    model: {
      value: (_vm.isVehicleReplacedCheck),
      callback: function($$v) {
        _vm.isVehicleReplacedCheck = $$v
      },
      expression: "isVehicleReplacedCheck"
    }
  }, [_vm._v("Is Vehicle Replaced?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Delivery Option")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    ref: "deliveryOption",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "deliveryOption",
      "options": _vm.deliveryOptionList,
      "selected-option": _vm.deliveryOptionItemObj,
      "name": "deliveryOption",
      "placeholder": "Select Delivery Option"
    },
    on: {
      "select": _vm.selectDeliveryOption
    },
    model: {
      value: (_vm.deliveryOption),
      callback: function($$v) {
        _vm.deliveryOption = $$v
      },
      expression: "deliveryOption"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliveryOption')),
      expression: "errors.has('deliveryOption')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('deliveryOption')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.vehicleNo == '' || _vm.vehicleOpenKM == '' || _vm.deliveryOption == ''
    },
    on: {
      "click": function($event) {
        return _vm.startAllocation(true)
      }
    }
  }, [_vm._v("Start Allocation")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.allocationLoader
    },
    on: {
      "update:active": function($event) {
        _vm.allocationLoader = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.allocation()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideAllocateFlag && (_vm.startAllocationFlag || !_vm.IsSRNeedTrip)),
      expression: "hideAllocateFlag && (startAllocationFlag || !IsSRNeedTrip)"
    }],
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Allocation")])]), _vm._v(" "), ((_vm.tripTitle != 'Start Trip') || !_vm.IsSRNeedTrip) ? _c('div', {
    staticClass: "col-md-6 mt-3"
  }, [_c('label', [_vm._v("Delivery Option")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "deliveryOption",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "deliveryOption",
      "options": _vm.deliveryOptionList,
      "selected-option": _vm.deliveryOptionItemObj,
      "name": "deliveryOption",
      "placeholder": "Select Delivery Option"
    },
    on: {
      "select": _vm.selectDeliveryOption
    },
    model: {
      value: (_vm.deliveryOption),
      callback: function($$v) {
        _vm.deliveryOption = $$v
      },
      expression: "deliveryOption"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliveryOption')),
      expression: "errors.has('deliveryOption')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('deliveryOption')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Hub Name : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srHubName))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("SR Name : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srName))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment No")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentNo),
      expression: "shipmentNo"
    }],
    ref: "shipmentNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter / Scan Shipment No",
      "autocomplete": "off",
      "name": "shipmentNo",
      "oncopy": "return false",
      "onpaste": "return false"
    },
    domProps: {
      "value": (_vm.shipmentNo)
    },
    on: {
      "drop": _vm.handleDragOver,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errShipmentNo),
      expression: "errShipmentNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errShipmentNo))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowEbnVehicleNo),
      expression: "flagShowEbnVehicleNo"
    }],
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ebnVehicleNo),
      expression: "ebnVehicleNo"
    }],
    ref: "ebnVehicleNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "ebnVehicleNo"
    },
    domProps: {
      "value": (_vm.ebnVehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ebnVehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errEbnVehicleNo),
      expression: "errEbnVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errEbnVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / MH 01 AB 0123)")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowEbnVehicleNo),
      expression: "flagShowEbnVehicleNo"
    }],
    staticClass: "col-md-9"
  }, [_c('dummy-input', {
    ref: "dummyShipInputBox",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  }), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": !_vm.flagAllocation
    }
  }, [_vm._v("Allocate")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flagShowEbnVehicleNo),
      expression: "!flagShowEbnVehicleNo"
    }],
    staticClass: "col-md-2 mr-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "submit",
      "disabled": !_vm.flagAllocation
    }
  }, [_vm._v("Allocate")])], 1)], 1)], 1), _vm._v(" "), _c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flagShowEbnVehicleNo),
      expression: "!flagShowEbnVehicleNo"
    }],
    ref: "dummyShipInputBox2",
    staticClass: "col-md-9 mt-3",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingAlc),
      expression: "isLoadingAlc"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('vue-element-loading', {
    style: (_vm.flagShowEbnVehicleNo == false ? 'margin-top: 48px' : ''),
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingAlc,
      "size": "30"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingAlc = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Web/Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6",
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromList,
      "selected-option": _vm.fromItemObj,
      "name": "from",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFrom
    },
    model: {
      value: (_vm.fromId),
      callback: function($$v) {
        _vm.fromId = $$v
      },
      expression: "fromId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-2"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isAllocation == false
    },
    on: {
      "click": function($event) {
        return _vm.confirmTrip()
      }
    }
  }, [_vm._v("Confirm Allocation")])], 1)], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isConfirmLoad,
      "text": "Please wait confirm trip is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirmLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "danger"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.allocationErrorMsg) + " "), _c('br'), _vm._v("\n                          " + _vm._s(_vm.allocationMsgprexo) + "\n                          "), (_vm.flagShowPreviousShipment) ? _c('i', {
    staticStyle: {
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ShowShipments
    }
  }, [_c('br'), _vm._v(" Click here to view pending shipments")]) : _vm._e()]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.allocationSuccessMsg)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.allocationMsgprexo) + "\n                        ")])], 1)])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticClass: "shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Pending Shipment List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.getAllPendingShipmentList('reload', _vm.shipmentType)
      }
    }
  }, [_c('vue-element-loading', {
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.075) !important"
    },
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPSL,
      "text": "Please wait loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPSL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setLocusFlag),
      expression: "!setLocusFlag"
    }],
    staticClass: "mb-2",
    staticStyle: {
      "border": "1px solid rgb(206, 206, 206) !important"
    }
  }, _vm._l((_vm.deliveryOptionListTab), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "col-sm-3",
      class: [_vm.activeTab === item.text ? 'activeTab' : 'normalTab'],
      on: {
        "click": function($event) {
          return _vm.onTabActivated(item.text)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item.text) + "\n                              ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.setLocusFlag),
      expression: "setLocusFlag"
    }],
    staticClass: "mb-2",
    staticStyle: {
      "border": "1px solid rgb(206, 206, 206) !important"
    }
  }, _vm._l((_vm.deliveryOptionListTab), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "col-sm-3",
      class: [_vm.activeTab === item.text ? 'activeTab' : 'normalTab'],
      on: {
        "click": function($event) {
          return _vm.onTabActivated(item.text)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item.text) + "\n                              ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setLocusFlag),
      expression: "!setLocusFlag"
    }],
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.getAllPendingShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PendingTabOptionKeyForLocus != 0 && _vm.setLocusFlag),
      expression: "PendingTabOptionKeyForLocus!=0 && setLocusFlag"
    }],
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.getAllPendingShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PendingTabOptionKeyForLocus == 0 && _vm.setLocusFlag),
      expression: "PendingTabOptionKeyForLocus==0 && setLocusFlag"
    }],
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.showPendingPickups('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.fullScreenPendingShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [(_vm.PendingTabOptionKey != 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PsearchByShippingId),
      expression: "PsearchByShippingId"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('PsearchByShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "PsearchByShippingId"
    },
    domProps: {
      "value": (_vm.PsearchByShippingId)
    },
    on: {
      "keydown": _vm.PendingShipmentDetailsOnkeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PsearchByShippingId = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingIdRvp),
      expression: "searchByShippingIdRvp"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingIdRvp')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "name": "searchByShippingIdRvp"
    },
    domProps: {
      "value": (_vm.searchByShippingIdRvp)
    },
    on: {
      "keydown": function($event) {
        return _vm.loadRVPShipmentDetails()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingIdRvp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        _vm.PendingTabOptionKey != 1 ? _vm.getAllPendingShipmentList('search') : _vm.loadRVPShipmentDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n                            "), (_vm.PendingTabOptionKey != 1) ? _c('div', [_c('table', {
    staticClass: "b-table table table-bordered ShipmentList"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Pending At Dest")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("RP ShippingId")]), _vm._v(" "), _c('th', [_vm._v("Total Attempts")]), _vm._v(" "), _c('th', [_vm._v("Last Status")]), _vm._v(" "), _c('th', [_vm._v("Shipping Date")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('th', [_vm._v("IsSame DayDelv.")]), _vm._v(" "), _c('th', [_vm._v("EDD")]), _vm._v(" "), _c('th', [_vm._v("Address Type")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("Exchange Type")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("Sub Cluster Name")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("Service Type")])])]), _vm._v(" "), _c('tbody', [(_vm.pendingShipmentList.length > 0) ? _vm._l((_vm.pendingShipmentList), function(row) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : '')
    }, [_c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CollectibleAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.isSameDayDelivery(row.IsSameDayDelivery)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.EDD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AddressType))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.SubClusterName))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.ServiceType))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPendingShipment > 20),
      expression: "totalPendingShipment>20"
    }],
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingRvpPickup
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingRvpPickup = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered ShipmentList",
    attrs: {
      "id": "shipmentListRvp"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAll),
      expression: "sAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAll) ? _vm._i(_vm.sAll, "") > -1 : (_vm.sAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.sAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("ReAttempt Count")]), _vm._v(" "), _c('th', [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', [_vm._v("Exchange Type")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pickupList), function(row, index) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : ''),
      attrs: {
        "id": 'rvpTr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickups),
        expression: "selectedPickups"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickups' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickups) ? _vm._i(_vm.selectedPickups, row.ShippingId) > -1 : (_vm.selectedPickups)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickups = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickups = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.ReAttemptDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CI' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pickupList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Allocated Shipment List'
    },
    attrs: {
      "title": "Allocated Shipment List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadSrShipmentDetails('reload')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#151B31",
      "font-size": "18px",
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.loadSrShipmentDetails('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Allocated Shipment List"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticClass: "bagin-dtl1"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.srShipmentList.length))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId),
      expression: "searchByShippingId"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadSrShipmentDetails('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n\n                            "), _c('table', {
    staticClass: "b-table table table-bordered ShipmentList"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Ship Pincode")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("Service Type")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', [_vm._v("Exchange Type")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', [(_vm.srShipmentList.length > 0) ? _vm._l((_vm.srShipmentList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ServiceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipment(row.ShippingID)
        }
      }
    })])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])], 1)], 1)], 1)])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("SR Name : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openKm),
      expression: "openKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "openKm"
    },
    domProps: {
      "value": (_vm.openKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorOpenKM),
      expression: "errorOpenKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorOpenKM))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeKm),
      expression: "closeKm"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Close KM",
      "name": "closeKm"
    },
    domProps: {
      "value": (_vm.closeKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closeKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCloseKM),
      expression: "errorCloseKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorCloseKM))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.closeKm == '' || _vm.openKm == ''
    },
    on: {
      "click": function($event) {
        return _vm.verifyTrip()
      }
    }
  }, [_vm._v("Verify/Modify")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeCloseTripModel()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.pendingShipModel),
      callback: function($$v) {
        _vm.pendingShipModel = $$v
      },
      expression: "pendingShipModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePendingShipModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPSLModel
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPSLModel = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setLocusFlag),
      expression: "!setLocusFlag"
    }],
    staticClass: "col-md-6 mb-3",
    staticStyle: {
      "border": "1px solid rgb(206, 206, 206) !important"
    }
  }, _vm._l((_vm.deliveryOptionListTab), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "col-sm-3",
      class: [_vm.activeTab === item.text ? 'activeTab' : 'normalTab'],
      on: {
        "click": function($event) {
          return _vm.onTabActivated(item.text)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(item.text) + "\n                            ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.setLocusFlag),
      expression: "setLocusFlag"
    }],
    staticClass: "col-md-6 mb-3",
    staticStyle: {
      "border": "1px solid rgb(206, 206, 206) !important"
    }
  }, _vm._l((_vm.deliveryOptionListTab), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "col-sm-3",
      class: [_vm.activeTab === item.text ? 'activeTab' : 'normalTab'],
      on: {
        "click": function($event) {
          return _vm.onTabActivated(item.text)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item.text) + "\n                              ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [(_vm.PendingTabOptionKey != 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PsearchByShippingId),
      expression: "PsearchByShippingId"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('PsearchByShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "PsearchByShippingId"
    },
    domProps: {
      "value": (_vm.PsearchByShippingId)
    },
    on: {
      "keydown": _vm.PendingShipmentDetailsOnkeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PsearchByShippingId = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingIdRvp),
      expression: "searchByShippingIdRvp"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingIdRvp')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "name": "searchByShippingIdRvp"
    },
    domProps: {
      "value": (_vm.searchByShippingIdRvp)
    },
    on: {
      "keydown": function($event) {
        return _vm.loadRVPShipmentDetails()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingIdRvp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        _vm.PendingTabOptionKey != 1 ? _vm.getAllPendingShipmentList('search') : _vm.loadRVPShipmentDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n                          ")])]), _vm._v(" "), (_vm.PendingTabOptionKey != 1) ? _c('div', [_c('table', {
    staticClass: "b-table table table-bordered ShipmentList"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Pending At Dest")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("RP ShippingId")]), _vm._v(" "), _c('th', [_vm._v("Total Attempts")]), _vm._v(" "), _c('th', [_vm._v("Last Status")]), _vm._v(" "), _c('th', [_vm._v("Shipping Date")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('th', [_vm._v("IsSame DayDelv.")]), _vm._v(" "), _c('th', [_vm._v("EDD")]), _vm._v(" "), _c('th', [_vm._v("Address Type")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("Exchange Type")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("Sub Cluster Name")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
      expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
    }]
  }, [_vm._v("Service Type")])])]), _vm._v(" "), _c('tbody', [(_vm.pendingShipmentList.length > 0) ? _vm._l((_vm.pendingShipmentList), function(row) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : '')
    }, [_c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CollectibleAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.isSameDayDelivery(row.IsSameDayDelivery)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.EDD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AddressType))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery', 'rvp'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery', 'rvp'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.SubClusterName))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['forward', 'delivery'].includes(_vm.PendingListdeliveryOpt.toLowerCase())),
        expression: "['forward', 'delivery'].includes(PendingListdeliveryOpt.toLowerCase())"
      }]
    }, [_vm._v(_vm._s(row.ServiceType))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPendingShipment > 20),
      expression: "totalPendingShipment>20"
    }],
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _c('div', {
    class: {
      rvpContHidden: _vm.isActiveRvp,
      tableFixHead: true
    },
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingRvpPickup
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingRvpPickup = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered ShipmentList",
    attrs: {
      "id": "shipmentListRvp"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAll),
      expression: "sAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAll) ? _vm._i(_vm.sAll, "") > -1 : (_vm.sAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.sAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("ReAttempt Count")]), _vm._v(" "), _c('th', [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', [_vm._v("Exchange Type")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pickupList), function(row, index) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : ''),
      attrs: {
        "id": 'rvpTr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickups),
        expression: "selectedPickups"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickups' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickups) ? _vm._i(_vm.selectedPickups, row.ShippingId) > -1 : (_vm.selectedPickups)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickups = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickups = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.ReAttemptDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CI' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pickupList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipModel()
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('pending-Pods', {
    attrs: {
      "isPendingPodsLoader": _vm.isPodsLoader,
      "IsPaperlessFlyerbarcode": _vm.IsPaperlessFlyerbarcode,
      "showShipmentList": _vm.showShipmentList
    },
    model: {
      value: (_vm.showShipmentModel),
      callback: function($$v) {
        _vm.showShipmentModel = $$v
      },
      expression: "showShipmentModel"
    }
  }), _vm._v(" "), (_vm.rvpShipmentsModel == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "RVP Allocated Shipment",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeRvpShipmentsModel
    },
    model: {
      value: (_vm.rvpShipmentsModel),
      callback: function($$v) {
        _vm.rvpShipmentsModel = $$v
      },
      expression: "rvpShipmentsModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RVP Allocated Shipment")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRvpShipmentsModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingRvpPickup
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingRvpPickup = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("List\n                          "), _c('div', {
    staticClass: "SrName"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.srName) + " ")])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Pickups")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.pickupData,
      "selected-option": _vm.pickupItem,
      "name": "fltpickup",
      "placeholder": "Select Pickup"
    },
    on: {
      "select": _vm.selectPickups
    },
    model: {
      value: (_vm.fltpickup),
      callback: function($$v) {
        _vm.fltpickup = $$v
      },
      expression: "fltpickup"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("From / To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "lang": "en",
      "name": "fromToDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.fromToDate),
      callback: function($$v) {
        _vm.fromToDate = $$v
      },
      expression: "fromToDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showPendingPickups
    }
  }, [_vm._v("Show Pending Pickups")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Select Web/Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromList,
      "selected-option": _vm.fromItemObj,
      "name": "from",
      "isDisabled": "",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFrom
    },
    model: {
      value: (_vm.fromId),
      callback: function($$v) {
        _vm.fromId = $$v
      },
      expression: "fromId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedPickups.length == 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.checkPendingForRVP()
      }
    }
  }, [_vm._v("Allocate Pickup")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isAllocationRvp == false
    },
    on: {
      "click": function($event) {
        return _vm.CheckPDD()
      }
    }
  }, [_vm._v("Confirm Trip")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.errorRvpAllocation || _vm.successRvpAllocation) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorRvpAllocation) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.errorRvpAllocationErrorArrobj), function(singleRvpError) {
    return [_c('span', [_vm._v(_vm._s(singleRvpError.shippingId) + " :- " + _vm._s(singleRvpError.message))]), _c('br'), _vm._v(" "), (singleRvpError.prexoShipment) ? _c('span', [_vm._v(_vm._s(_vm.rvpPrexoShipMsg) + " " + _vm._s(singleRvpError.prexoShipment))]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.successRvpAllocation) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                                 " + _vm._s(_vm.successRvpAllocation) + " "), _c('br'), _vm._v(" "), (_vm.rvpPrexoShipmentList.length == 1) ? _c('span', [_vm._v("\n                                  " + _vm._s(_vm.rvpPrexoShipMsg) + " " + _vm._s(_vm.rvpPrexoShipmentList) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.rvpPrexoShipmentList.length > 1) ? _c('span', [_vm._v("\n                                  " + _vm._s(_vm.rvpPrexoShipMsgBulk) + " " + _vm._s(_vm.rvpPrexoShipmentList) + "\n                                ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.morePendingRVPShipmentsModel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.IsrvpMPSAllocation) ? _c('h5', [_vm._v("Below Shipments are from same customer, Please allocate them to same SR. ")]) : _c('h5', [_vm._v(_vm._s(_vm.mpsErrorLabel) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.preMPSValidationCheck()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeMPRVPShipments()
      }
    }
  }, [_vm._v(" Cancel")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAllMoreShip),
      expression: "sAllMoreShip"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAllMoreShip) ? _vm._i(_vm.sAllMoreShip, "") > -1 : (_vm.sAllMoreShip)
    },
    on: {
      "click": _vm.selectAllMoreRVPShipments,
      "change": function($event) {
        var $$a = _vm.sAllMoreShip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAllMoreShip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAllMoreShip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAllMoreShip = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("MPS Group ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")]), _vm._v(" "), _c('th', [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', [_vm._v("Exchange Type")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.suggestRVPArrayList), function(row, index) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : ''),
      attrs: {
        "id": 'rvpTrMr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickupsMore),
        expression: "selectedPickupsMore"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickupsMore' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickupsMore) ? _vm._i(_vm.selectedPickupsMore, row.ShippingId) > -1 : (_vm.selectedPickupsMore)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickupsMore,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickupsMore = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickupsMore = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickupsMore = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.MultiShipmentGroupID) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CIMr' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pickupList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "shipmentListtab1"
  }, [_c('div', {
    staticClass: "tab-link",
    class: {
      active: _vm.indexTab == 1
    },
    on: {
      "click": function($event) {
        return _vm.showPendingPickups()
      }
    }
  }, [_vm._v("Pending RVP Shipment List")]), _vm._v(" "), _c('div', {
    staticClass: "tab-link",
    class: {
      active: _vm.indexTab == 2
    },
    on: {
      "click": function($event) {
        _vm.morePendingRVPShipmentsModel == true ? '' : _vm.loadRVPAllocatedShipmentList()
      }
    }
  }, [_vm._v("Allocated RVP Shipment List")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexTab == 1),
      expression: "indexTab == 1"
    }],
    staticClass: "tab1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      row: true
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingIdRvp),
      expression: "searchByShippingIdRvp"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingIdRvp')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "name": "searchByShippingIdRvp"
    },
    domProps: {
      "value": (_vm.searchByShippingIdRvp)
    },
    on: {
      "keydown": function($event) {
        return _vm.loadRVPShipmentDetails()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingIdRvp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadRVPShipmentDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "bagin-dtl1",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.pickupList.length))])])]), _vm._v(" "), _c('div', {
    class: {
      row: true,
      rvpContHidden: _vm.isActiveRvp,
      tableFixHead: true
    },
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered ShipmentList",
    attrs: {
      "id": "shipmentListRvp"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAll),
      expression: "sAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAll) ? _vm._i(_vm.sAll, "") > -1 : (_vm.sAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.sAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("MPS Group ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("ReAttempt Count")]), _vm._v(" "), _c('th', [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', [_vm._v("Exchange Type")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.SearchpickupList), function(row, index) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : ''),
      attrs: {
        "id": 'rvpTr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickups),
        expression: "selectedPickups"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickups' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickups) ? _vm._i(_vm.selectedPickups, row.ShippingId) > -1 : (_vm.selectedPickups)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickups = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickups = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.MultiShipmentGroupID) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.ReAttemptDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ExchangeType))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CI' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pickupList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexTab == 2),
      expression: "indexTab == 2"
    }],
    staticClass: "tab2"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      row: true
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingIdRvpASL),
      expression: "searchByShippingIdRvpASL"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingIdRvpASL')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "name": "searchByShippingIdRvpASL"
    },
    domProps: {
      "value": (_vm.searchByShippingIdRvpASL)
    },
    on: {
      "keydown": function($event) {
        return _vm.loadRVPAllocatedShipmentDetails()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingIdRvpASL = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadRVPAllocatedShipmentDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "bagin-dtl1",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.RVPAllocatedShipmentList.length))])])]), _vm._v(" "), _c('div', {
    class: {
      row: true,
      rvpContHidden: _vm.isActiveRvp
    },
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered ShipmentList",
    attrs: {
      "id": "shipmentListRvpAllocated"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Ship Pincode")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("Service Type")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("PreXo ID")]), _vm._v(" "), _c('th', [_vm._v("Exchange Type")])])]), _vm._v(" "), _c('tbody', [(_vm.RVPAllocatedShipmentList.length > 0) ? _vm._l((_vm.RVPAllocatedShipmentList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ServiceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PrexoID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ExchangeType))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])], 1)])])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeRvpShipmentsModel
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), (_vm.NonAllocationRsn == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.NonAllocationRsn),
      callback: function($$v) {
        _vm.NonAllocationRsn = $$v
      },
      expression: "NonAllocationRsn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [(_vm.BucketName != 'Heavies') ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reason")]) : _vm._e(), _vm._v(" "), (_vm.BucketName == 'Heavies') ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alert - Heavies Shipments")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.BucketName != 'Heavies') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.TitleName))]) : _vm._e(), _vm._v(" "), (_vm.BucketName == 'Heavies') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.heaviesTitleName1)), _c('h6', [_c('b', [_vm._v(_vm._s(_vm.heaviesTitleName2))])])]) : _vm._e()]), _vm._v(" "), (_vm.BucketName != 'Heavies') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "margin-top": "3px"
    }
  }, [_vm._v("Please select the reason of non-allocation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Reason:")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    attrs: {
      "name": "Reason",
      "placeholder": "Select",
      "options": _vm.ReasonList,
      "selected-option": _vm.ReasonObj
    },
    on: {
      "select": _vm.selectReason
    },
    model: {
      value: (_vm.Reason),
      callback: function($$v) {
        _vm.Reason = $$v
      },
      expression: "Reason"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.BucketName == 'Heavies') ? _c('div', {
    staticClass: "col-md-12 mt-2",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default tablehead"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipments")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.SEQShippingids), function(shipmentId, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentId))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.BucketName == 'Heavies') ? _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitHeavies()
      }
    }
  }, [_vm._v("Continue")]), _vm._v("     \n                      "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_vm._v("cancel")])]) : _vm._e(), _vm._v(" "), (_vm.BucketName != 'Heavies') ? _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitNonAllocationRsn()
      }
    }
  }, [_vm._v("Submit")]), _vm._v("     \n                        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_vm._v("close")])]) : _vm._e()])])])])])]) : _vm._e()], 1)]), _vm._v(" "), _c('pending-group-id-shipment', {
    attrs: {
      "pendingGrouptErrorMsg": _vm.pendingGrouptErrorMsg,
      "isPendingGroupIdLoader": _vm.isGroupIdLoader,
      "showParentGroupIdShipmentList": _vm.showParentGroupIdShipmentList
    },
    on: {
      "getCloseModelEvent": _vm.getCloseModelEvent
    },
    model: {
      value: (_vm.showGroupIdShipmentModel),
      callback: function($$v) {
        _vm.showGroupIdShipmentModel = $$v
      },
      expression: "showGroupIdShipmentModel"
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Print Shipment For Delivery")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srListFlt,
      "selected-option": _vm.srItemObjFlt,
      "name": "SRFlt",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSRFlt
    },
    model: {
      value: (_vm.srIdFlt),
      callback: function($$v) {
        _vm.srIdFlt = $$v
      },
      expression: "srIdFlt"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SRFlt')),
      expression: "errors.has('SRFlt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SRFlt')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Delivery Option")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.deliveryOptionListPrint,
      "selected-option": _vm.deliveryOptionItemObjPrint,
      "name": "deliveryOptionPrint",
      "placeholder": "Select Delivery Option"
    },
    on: {
      "select": _vm.selectDeliveryOptionPrint
    },
    model: {
      value: (_vm.deliveryOptionPrint),
      callback: function($$v) {
        _vm.deliveryOptionPrint = $$v
      },
      expression: "deliveryOptionPrint"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableBatchID && _vm.deliveryOptionPrint == 'RVP'),
      expression: "disableBatchID && deliveryOptionPrint=='RVP'"
    }],
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Batch Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.deliveryOptionPrint == 'RVP' ? 'required' : ''),
      expression: "deliveryOptionPrint=='RVP' ? 'required' : '' "
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.batchIdListPrint,
      "selected-option": _vm.batchIdItemObjPrint,
      "name": "batchIdPrint",
      "placeholder": "Select Batch Id"
    },
    on: {
      "select": _vm.selectBatchIdPrint
    },
    model: {
      value: (_vm.batchIdPrint),
      callback: function($$v) {
        _vm.batchIdPrint = $$v
      },
      expression: "batchIdPrint"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableFrom),
      expression: "disableFrom"
    }],
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    } && {
      'disabled': true
    },
    attrs: {
      "options": _vm.fromListFlt,
      "selected-option": _vm.fromItemObjFlt,
      "name": "from",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFromFlt
    },
    model: {
      value: (_vm.fromIdFlt),
      callback: function($$v) {
        _vm.fromIdFlt = $$v
      },
      expression: "fromIdFlt"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('from')),
      expression: "errors.has('from')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('from')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "batchCreatedDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.batchCreatedDate),
      callback: function($$v) {
        _vm.batchCreatedDate = $$v
      },
      expression: "batchCreatedDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.srIdFlt == false || _vm.isLoadPDF == true || _vm.isLoadBatch == true || _vm.isLoadingPrint == true
    },
    on: {
      "click": function($event) {
        return _vm.printShipmentForDelivery()
      }
    }
  }, [_vm._v("Print Shipments")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.srShipmentPrintList.length > 0 && _vm.showconfirmPrint == true),
      expression: "srShipmentPrintList.length>0  && showconfirmPrint ==true"
    }],
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoadingPrint
    },
    on: {
      "click": function($event) {
        return _vm.printShipments()
      }
    }
  }, [_vm._v("Confirm Print")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.srIdFlt == false || _vm.isLoadPDF == true || _vm.isLoadBatch == true || _vm.isLoadingPrint == true
    },
    on: {
      "click": function($event) {
        return _vm.resetPrint()
      }
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadBatch,
      "text": "Please wait to batch table get open..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadBatch = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadPDF,
      "text": "Please wait.... PDF is being generating.!"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadPDF = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.batchIdListPrint.length > 0) ? _c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Delivery User")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No Of Shipments")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO') && _vm.drsflag == false),
      expression: "futuredate==true && (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO') && drsflag == false"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Delivery PDF ")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO')),
      expression: "futuredate==true && (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO')"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Vendor PDF ")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO') && _vm.drsflag == false),
      expression: "futuredate==true && (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO') && drsflag == false"
    }],
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Vendor xls")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.batchIdListPrint), function(row, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ("{{index}}==0"),
        expression: "`{{index}}==0`"
      }]
    }, [_vm._v(_vm._s(_vm.srItemObjFlt.text))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.pastdate == true || (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO')),
        expression: "pastdate==true || (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO')"
      }]
    }, [_vm._v(_vm._s(row.AssignBatchNo))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RVP' || _vm.deliveryOptionPrint == 'Delivery')),
        expression: "futuredate==true && (deliveryOptionPrint=='RVP' || deliveryOptionPrint=='Delivery')"
      }]
    }, [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.printShipmentForRVP(row.AssignBatchNo, 'delivery')
        }
      }
    }, [_c('u', [_c('font', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(row.AssignBatchNo))])], 1)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("batchCreatedDateFormat")(_vm.batchCreatedDate)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.exportCSVOfShippingIDS(row.shippingIDArray)
        }
      }
    }, [_c('u', [_c('font', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(row.NoOfShipments))])], 1)])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO') && _vm.drsflag == false),
        expression: "futuredate==true && (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO') && drsflag == false"
      }],
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.printShipmentForRVP(row.AssignBatchNo, 'delivery')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o",
      staticStyle: {
        "font-size": "20px",
        "color": "black"
      }
    })])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO')),
        expression: "futuredate==true && (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO')"
      }],
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.printShipmentForRVP(row.AssignBatchNo, 'vendor')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o",
      staticStyle: {
        "font-size": "20px"
      }
    })])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.futuredate == true && (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO') && _vm.drsflag == false),
        expression: "futuredate==true && (deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO') && drsflag == false"
      }],
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.printShipmentForRVP(row.AssignBatchNo, 'olddrs')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o",
      staticStyle: {
        "font-size": "20px"
      }
    })])])])
  }), 0)]) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.openDRSModel),
      callback: function($$v) {
        _vm.openDRSModel = $$v
      },
      expression: "openDRSModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseDRSModel()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "margin-top": "3px"
    }
  }, [_vm._v("Vendors printed : " + _vm._s(_vm.drsbatchdetails))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "margin-top": "3px"
    }
  }, [_vm._v("Shipments printed : " + _vm._s(_vm.drsshipmentdetails))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black",
      "margin-top": "3px"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" DRS does not include Shipments and Vendors where\n                          OTP is mandatory.")])]), _vm._v(" "), _c('div', {
    staticClass: "model-footer col-sm-12 text-center"
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openDRSAndClose
    }
  }, [_vm._v(" Print\n                          Runsheet")])])])])])])])])], 1)])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-261857e4","hasScoped":false}!./src/views/components/Allocation/Allocation.html
// module id = 1204
// module chunks = 1